import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
import { defaultToday, PRICELINE_DATE_FORMAT } from '../../constants/dates';
function getInitialHoveredDate({
  endDate,
  minDate,
  selectTwoDates,
  startDate
}) {
  const fallbackDate = minDate ? format(parseISO(minDate.toString()), PRICELINE_DATE_FORMAT) : defaultToday;
  if (selectTwoDates) {
    return endDate ? format(parseISO(endDate.toString()), PRICELINE_DATE_FORMAT) : fallbackDate;
  } else {
    return startDate ? format(parseISO(startDate.toString()), PRICELINE_DATE_FORMAT) : fallbackDate;
  }
}
export default getInitialHoveredDate;